import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../common';

import { DirectConnect } from './direct-connect/direct-connect';
import { DirectConnectDetail } from './direct-connect/direct-connect-detail';
import { Gateways } from './gateways/gateways';
import { CreateGateway } from './gateways/create-gateway';
import { IpCountValidator } from './gateways/ip-count-validator';
import { OrgVdcNetworks } from './org-vdc-networks/org-vdc-networks';
import { OrgVdcNetworkDetail } from './org-vdc-networks/org-vdc-network-detail';
import { DirectConnectModule } from './direct-connect/direct-connect.module';
import { NetworksLanding } from './networks-landing.component';

@NgModule({
    declarations: [
        NetworksLanding,
        DirectConnect,
        DirectConnectDetail,
        Gateways,
        CreateGateway,
        IpCountValidator,
        OrgVdcNetworks,
        OrgVdcNetworkDetail
    ],
    imports: [
        VcaCommonModule,
        BrowserModule,
        FormsModule,
        TranslateModule,
        ClarityModule.forRoot(),
        RouterModule,
        DirectConnectModule
    ],
    providers: [
    ],
    exports: [
        DirectConnect,
        DirectConnectDetail,
        Gateways,
        OrgVdcNetworks,
        OrgVdcNetworkDetail,
        NetworksLanding
    ]
})

export class NetworkModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/network/network.module.ts